import * as types from './types';

const INITIAL_STATE = {
  settings: {
    w: 500,
    h: 500,
    t: 0,
    l: 0,
    color: '#ffffff',
    isLocked: false,
    label: 'Auto scale (default)',
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CHANGE_PAGE_SETTING:
      return {
        ...state,
        settings: { ...state.settings, ...action.payload },
      };
    default:
      return state;
  }
};
